<template>
<div style="margin-bottom:3rem">

  <!-- DIALO  WITH OPTIONS  -->
  <v-dialog :class="{'filtr-active':showFilter}" width="1000" v-model="show">
    <v-btn block color="primary" slot="activator">
      {{ $t('archive.filter.filters') }}
    </v-btn>
    <v-card>
      <v-card-title class="headline" primary-title>
        {{ $t('archive.filter.filters') }}
      </v-card-title>
      <v-container>
        <div>
          <h2> {{ $t('archive.filter.choose_filter') }}</h2>
          <v-layout>
          <v-flex xs11>
          <v-select :items="filters" item-text="name" item-value="id" v-model="choosenFilter" @change="updateConditionFilter" :label="`${$t('form.inputs.select_field')}`"></v-select>
          </v-flex>
          <v-flex xs1 v-if="editMode">
            <v-btn small fab @click="deleteFilter">
              <v-icon small>delete</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        </div>

        <div v-if="choosenFilter!=0">
          <div>
            <v-switch v-model="editMode" :label="`Edytuj filtr`"></v-switch>
            <div>
              <h3> {{ $t('archive.filter.contains') }} : </h3>
              <div :key="i" v-for="i in rangeContains">
                <v-layout>
                  <v-flex v-if="i!=1" xs5 sm3>
                    <v-select :readonly="!editMode" style="margin-left:2rem;" prepend-icon="xxyyzz" :items="operators" item-text="name" item-value="value" v-model="operatorsContains[i]" :label="`${$t('archive.filter.operator')}`"></v-select>
                  </v-flex>
                  <v-flex xs5 sm3>
                    <v-text-field :readonly="!editMode" style="margin-left:2rem;" v-model="searchContains[i]" prepend-icon="search" :label="`${$t('archive.filter.phrase')}`" required></v-text-field>
                  </v-flex>
                  <v-flex xs2 sm1>
                    <v-btn v-if="i!=1 && editMode" style="margin-left:2rem;" fab small block @click="removeFiltrContains(i)">
                      <v-icon small>remove</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex v-if="i==rangeContains && editMode" xs2 sm2>
                    <v-btn fab small @click="rangeContains++">
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </div>

            <div>
              <h3> {{ $t('archive.filter.not_contains') }} : </h3>
              <div :key="i" v-for="i in rangeNot">
                <v-layout>
                  <v-flex v-if="i!=1" xs5 sm3>
                    <v-select :readonly="!editMode" style="margin-left:2rem;" prepend-icon="xxyyzz" :items="operators" item-text="name" item-value="value" v-model="operatorsNot[i]" :label="`${$t('archive.filter.operator')}`"></v-select>
                  </v-flex>
                  <v-flex xs5 sm3>
                    <v-text-field :readonly="!editMode" style="margin-left:2rem;" v-model="searchNot[i]" prepend-icon="search" :label="`${$t('archive.filter.phrase')}`" required></v-text-field>
                  </v-flex>
                  <v-flex xs2 sm1>
                    <v-btn v-if="i!=1 && editMode" style="margin-left:2rem;" fab small block @click="removeFiltrNot(i)">
                      <v-icon small>remove</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex v-if="i==rangeNot && editMode" xs2 sm2>
                    <v-btn fab small @click="rangeNot++">
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </div>

          <!--  FILTRACJA   -->
          <v-layout style="margin-top:1rem">

            <v-flex xs4>
              <v-text-field v-model="type" :label="`${$t('archive.arch_type')}`" required></v-text-field>
            </v-flex>

          </v-layout>
          <v-layout>
            <v-flex>
              <v-btn @click="search">
                {{ $t('archive.filter.search') }}
              </v-btn>
              <v-btn v-if="editMode" @click="update">
                {{ $t('archive.filter.update_and_save') }}
              </v-btn>
            </v-flex>

            <!-- Nazwa filtra -->
          </v-layout>
          <!-- KONIEC FILTRACJI -->
        </div>
      </v-container>
    </v-card>
  </v-dialog>
  <!-- END DIALOG -->

</div>
</template>

<script>

export default {
  components: {
  },
  computed: {
    filters() {
      return this.$store.getters.archiveFilters
    },
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  data() {
    return {
      name: "",
      show: false,
      type:"",
      editMode: false,
      showSaveNameDialog: false,
      showSaveName: false,
      searchContains: [],
      rangeContains: 1,
      operatorsContains: [],
      searchNot: [],
      rangeNot: 1,
      operatorsNot: [],
      createFiltrer: true,
      sort: 1,
      place: 2,
      showFilter: false,
      operators: [{
          name: "AND",
          value: "AND"
        },
        {
          name: "OR",
          value: "OR"
        }
      ],
      choosenFilter: 0
    }
  },
  methods: {
    removeFiltrContains(index) {
      this.operatorsContains.splice(index, 1);
      this.searchContains.splice(index, 1)
      this.rangeContains--;
    },
    removeFiltrNot(index) {
      this.operatorsNot.splice(index, 1);
      this.searchNot.splice(index, 1)
      this.rangeNot--;
    },
    buildCondition() {
      let condition = {
        "name": this.name,
        "type": this.type
      }
      condition["contains"] = this.buildConditionFromData(this.searchContains, this.operatorsContains, this.rangeContains)
      condition["not"] = this.buildConditionFromData(this.searchNot, this.operatorsNot, this.rangeNot)
      return condition
    },
    buildConditionFromData(search, operatos, range) {
      let condition = []

      for (let i = 0; i <= range; i++) {
        if (search[i] == undefined || (operatos[i] == undefined && i > 1)) { // Ignore if search is empty or operator is empty when is needed (any field axcept first)
          continue;
        }
        let objCondition = {
          "id": i,
          search: search[i]
        }

        if (i > 1) {
          objCondition.operator = operatos[i]
        }
        condition.push(objCondition)
      }
      return condition
    },
    update() {
      let filters = this.buildCondition();
      if ((Object.keys(filters.contains).length > 0 || Object.keys(filters.not).length > 0) && this.choosenFilter > 0) {
      this.$store.dispatch('updateArchiveFilter',{ id:this.choosenFilter, data: filters }).then((data) => {
          this.show=false
          this.showMessage(this.$t('archive.filter.updated'), "success")
          this.$emit('filter', data.data)
        }).catch(() => {
          this.showMessage(this.$t('archive.filter.updated_fail'), "danger")
        })

      }
    },
    search() {
      let filter = this.filters.find(filt => filt.id == this.choosenFilter)
      this.show = false
      this.$emit('filter', filter)
    },
    deleteFilter() {
      let id = this.choosenFilter
      this.$store.dispatch('deleteArchiveFilter',id).then(() => {
        this.choosenFilter = 0
        this.showMessage(this.$t('archive.filter.deleted'), "success")
      }).catch(() => {
        this.showMessage(this.$t('archive.filter.cannot_delete'), "danger")
      })
    },
    updateConditionFilter() {
      this.clearConditions();

      if (this.choosenFilter == 0) {
        return;
      }

      this.editMode = false
      let filter = this.filters.find(filter => filter.id == this.choosenFilter)
      this.setUpCondition(filter)

    },
    setUpCondition(filter) {
      filter.contains.forEach(con => {
        this.searchContains[con.id] = con.search
        this.rangeContains++;
        if (con.id > 1)
          this.operatorsContains[con.id] = con.operator
      })

      filter.not.forEach(con => {
        this.searchNot[con.id] = con.search
        this.rangeNot++;
        if (con.id > 1)
          this.operatorsNot[con.id] = con.operator
      })

      this.sort = filter.sort
      this.place = filter.place
      this.name = filter.name
      this.type = filter.type

      if (filter.not.length > 1)
        this.rangeNot--

      if (filter.contains.length > 1)
        this.rangeContains--

    },
    clearConditions() {
      this.searchNot = []
      this.rangeNot = 1;
      this.operatorsNot = []

      this.searchContains = []
      this.rangeContains = 1;
      this.operatorsContains = []
    },
    showMessage(text, color) {
      this.$store.commit("setSnack", {
        message: text,
        color: color,
      })
    }
  },
  created() {

  }
}
</script>

<style>
.loading-circle {
  margin: 20px;
}

.apexcharts-canvas.dark {
  background: transparent !important;
}

.filtr-active {
  background-color: green !important;
}
</style>
